import { SkeletonRect } from '@ekhodealer/ekho-common/rev';

import { AccordionSection } from '@common/components/AccordionSection';

interface SectionSkeletonProps {
	title: string;
}

export const SectionSkeleton = ({ title }: SectionSkeletonProps) => {
	return (
		<AccordionSection title={title} defaultExpanded>
			<div style={{ opacity: 0.5 }}>
				<SkeletonRect width='100%' height={160} />
			</div>
		</AccordionSection>
	);
};
